import type React from 'react';

import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

type Props = {
  button?: React.ReactNode;
  customTitle?: string;
  hideDivider?: boolean;
  title?: string;
};
const ViewHeader: React.FC<Props> = props => {
  const { t } = useTranslation();
  const { button, customTitle, hideDivider = false, title } = props;

  return (
    <Stack spacing={0}>
      <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', m: 2 }}>
        <Box sx={{ alignItems: 'center', display: 'flex' }}>
          <Typography sx={{ pl: 2 }} variant="f20Medium">
            {customTitle ?? t(`pageTitles.${title}`)}
          </Typography>
        </Box>
        {button && <Box>{button}</Box>}
      </Stack>
      {!hideDivider && <Divider />}
    </Stack>
  );
};

export default ViewHeader;
